<template>
    <div class="sidebar-speq">
        <div class="brand-link px-4">
            <img
                src="/images/speq-logo.png"
                alt="SilencerCo"
                class="brand-image"
            />
        </div>
        <!-- Sidebar -->
        <div class="sidebar">
            <div class="user-panel px-3 pb-4">
                <div v-if="user.role.id == 2 || user.role.id == 3" class="info">
                    <div class="name pb-2">{{ currentLocation?.name }}</div>
                    <div v-if="currentLocation?.address" class="store pb-2">
                        {{ currentLocation?.address }}, <br />
                        {{ currentLocation?.city }}, {{ currentLocation?.state }},
                        {{ currentLocation?.zip_code }}
                    </div>
                    <div
                        v-if="user.locations.length > 1"
                        class="change-store"
                        @click="modalShowStore = !modalShowStore"
                    >
                        <i class="fa-solid fa-pencil"></i> CHANGE LOCATION
                    </div>
                </div>
                <div v-else class="info text-uppercase">
                    <div class="name pb-2">{{ user.role.display_name }}</div>
                </div>
            </div>

            <!-- TO DEALER PORTAL -->
            <nav class="">
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item" @click="switchToDealerPortal">
                        <a aria-current="page" href="#" class="nav-link to-dealer-nav">
                            <p>
                                <span class="text-orange">DEALER PORTAL</span>
                                <i class="nav-icon fa fa-arrow-right" aria-hidden="true"></i>
                            </p>
                        </a>
                    </li>
                </ul>
            </nav>

            <!-- Sidebar Menu for SUPER ADMIN -->
            <nav
                v-if="
                    user.role.id == 1 || user.role.id == 4 || user.role.id == 5
                "
                class="mt-2"
            >
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq"
                            ><i
                                class="nav-icon fa fa-users"
                                aria-hidden="true"
                            ></i>
                            <p>DEALER USERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/dealers"
                            ><i
                                class="nav-icon fa fa-address-card"
                                aria-hidden="true"
                            ></i>
                            <p>DEALERS</p></router-link
                        >
                    </li>
                    <li
                        v-if="user.role.id == 1 || user.role.id == 4"
                        class="nav-item"
                    >
                        <router-link class="nav-link" to="/speq/sales-reps"
                            ><i
                                class="nav-icon fa fa-user"
                                aria-hidden="true"
                            ></i>
                            <p>ADMIN USERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/all-orders"
                            ><i
                                class="nav-icon fa fa-tasks"
                                aria-hidden="true"
                            ></i>
                            <p>ORDERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/open-serial-numbers"
                            ><i
                                class="nav-icon fa fa-tasks"
                                aria-hidden="true"
                            ></i>
                            <p>OPEN SERIAL NUMBERS</p></router-link
                        >
                    </li>
                    <!-- <li
                        v-if="
                            user.quote_access ||
                            user.role.name == 'quote_approver'
                        "
                        class="nav-item"
                    >
                        <router-link class="nav-link" to="/speq/quotes"
                            ><i
                                class="nav-icon fa fa-usd"
                                aria-hidden="true"
                            ></i>
                            <p>QUOTES</p></router-link
                        >
                    </li> -->
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/all-materials"
                            ><i
                                class="nav-icon fa fa-folder-open"
                                aria-hidden="true"
                            ></i>
                            <p>MATERIALS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link
                            class="nav-link"
                            to="/speq/all-available-inventories"
                            ><i
                                class="nav-icon fa fa-folder-open"
                                aria-hidden="true"
                            ></i>
                            <p>AVAILABLE INVENTORY</p></router-link
                        >
                    </li>
                    <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/speq/approval-queue"
                            ><i
                                class="nav-icon fa fa-folder-open"
                                aria-hidden="true"
                            ></i>
                            <p class="small">
                                SOT/FFL APPROVAL QUEUE
                            </p></router-link
                        >
                    </li> -->
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/admin-price-list"
                            ><i
                                class="nav-icon fa fa-usd"
                                aria-hidden="true"
                            ></i>
                            <p>PRICE LIST</p></router-link
                        >
                    </li>
                    <!-- <li
                        v-if="
                            buy_group_dates_users_with_access.includes(user.id)
                        "
                        class="nav-item"
                    >
                        <router-link class="nav-link" to="/speq/buy-group-dates"
                            ><i
                                class="nav-icon fa fa-folder-open"
                                aria-hidden="true"
                            ></i>
                            <p>BUY GROUP DATES</p></router-link
                        >
                    </li> -->
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/settings"
                            ><i
                                class="nav-icon fa fa-gear"
                                aria-hidden="true"
                            ></i>
                            <p>SETTINGS</p></router-link
                        >
                    </li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->

            <!-- Sidebar Menu for DEALER ADMIN -->
            <nav v-else-if="user.role.name == 'dealer_admin'" class="mt-2">
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq"
                            ><i
                                class="nav-icon fa-solid fa-gauge"
                                aria-hidden="true"
                            ></i>
                            <p>DASHBOARD</p></router-link
                        >
                    </li>
                    <li  class="nav-item">
                        <router-link class="nav-link" to="/speq/new-order"
                            ><i
                                class="nav-icon fa fa-cart-plus"
                                aria-hidden="true"
                            ></i>
                            <p>NEW ORDER</p>
                            <span class="order-count" v-if="orderCount > 0">{{
                                orderCount
                            }}</span></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/all-orders"
                            ><i
                                class="nav-icon fa fa-tasks"
                                aria-hidden="true"
                            ></i>
                            <p>ORDERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/open-serial-numbers"
                            ><i
                                class="nav-icon fa fa-tasks"
                                aria-hidden="true"
                            ></i>
                            <p>OPEN SERIAL NUMBERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/invoices"
                            ><i
                                class="nav-icon fa fa-list"
                                aria-hidden="true"
                            ></i>
                            <p>INVOICES</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/order-lines-report"
                            ><i
                                class="nav-icon fa fa-list"
                                aria-hidden="true"
                            ></i>
                            <p>OPEN ORDER LINES</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/price-lists"
                            ><i
                                class="nav-icon fa fa-usd"
                                aria-hidden="true"
                            ></i>
                            <p>PRICE LIST</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/speq/contact"
                            ><i
                                class="nav-icon fa fa-envelope"
                                aria-hidden="true"
                            ></i>
                            <p>CONTACT</p></router-link
                        >
                    </li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->

            <!-- Sidebar Menu for DEALER EMPLOYEE -->
            <nav v-else class="mt-2">
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item">
                        <router-link class="nav-link" to="/"
                            ><i
                                class="nav-icon fa-solid fa-gauge"
                                aria-hidden="true"
                            ></i>
                            <p>DASHBOARD</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/all-orders"
                            ><i
                                class="nav-icon fa fa-tasks"
                                aria-hidden="true"
                            ></i>
                            <p>MY ORDERS</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/invoices"
                            ><i
                                class="nav-icon fa fa-list"
                                aria-hidden="true"
                            ></i>
                            <p>INVOICES</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/price-lists"
                            ><i
                                class="nav-icon fa fa-usd"
                                aria-hidden="true"
                            ></i>
                            <p>PRICE LIST</p></router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/contact"
                            ><i
                                class="nav-icon fa fa-envelope"
                                aria-hidden="true"
                            ></i>
                            <p>CONTACT</p></router-link
                        >
                    </li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->

            

            <!-- DATA DISCLAIMER -->
            <nav class="mt-5">
                <ul
                    class="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                >
                    <li class="nav-item">
                        <div class="disclaimer">
                            <span class="text-muted">Data Disclaimer:</span
                            ><br />
                            <span class="text-muted"
                                >Your portal data is refreshed once per
                                day</span
                            >
                        </div>
                    </li>
                </ul>
            </nav>

            <!-- Portal Toggle -->
            <!-- <nav>
                <button
                    class="btn btn-dealer-toggle mt-2 mb-4"
                    @click="switchToDealerPortal"
                >
                    DEALER PORTAL
                </button>
            </nav> -->

            <!-- Brand Logo -->
            <!-- <div class="brand-link px-4 brand-logo-bottom">
                <img
                    src="/images/speq_icon.png"
                    alt="SilencerCo"
                    class="brand-image"
                />
            </div> -->
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import Orders from "@/components/orders/Orders.vue";

export default {
    props: ["user"],
    emits: [],
    components: {
        Orders,
    },
    setup() {
        const store = useStore();

        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let orders = computed(function () {
            return store.state.orders;
        });
        let isD2DUser = computed(function () {
            return store.state.isD2DUser;
        });

        let isSpeq = computed(function () {
            return store.state.isSpeq;
        });

        function setUser(val) {
            store.commit("setUser", val);
        }

        function setCurrentLocation(val) {
            store.commit("setCurrentLocation", val);
        }

        function checkIsD2DUser() {
            store.dispatch("getIsD2DUser");
        }

        onMounted(() => {});

        return {
            currentLocation,
            isD2DUser,
            orders,
            isSpeq,
            setUser,
            setCurrentLocation,
            checkIsD2DUser,
        };
    },
    data() {
        return {
            modalShowStore: false,
            buy_group_dates_users_with_access: JSON.parse(
                process.env.MIX_BUY_GROUP_DATES_USERS_WITH_ACCESS
            ),
            showD2Dbtn: false,
        };
    },
    computed: {
        orderCount() {
            let ctr = 0;
            if (this.orders) {
                for (let x = 0; x < this.orders.length; x++) {
                    if (this.orders[x].quantity > 0) {
                        ctr += this.orders[x].quantity;
                    }
                }
            }

            return ctr;
        },
    },
    mounted() {
        this.setUser(this.user);
        if (this.user.role.id != 1) {
            this.checkIsD2DUser();
        }

        this.$store.dispatch("getSettings", {
            location_id: this.currentLocation.id,
        });

        // Check if previous session was speq
        // @TODO update to add user validation later
        let isSpeq = localStorage.getItem("isSpeq");
        if (this.user.role.id == 1) {
            // this.$store.commit("setIsSpeq", isSpeq);
            // if (!this.isSpeq) {
            if (isSpeq != 'true') {
                // this.switchToDealerPortal()
                this.$store.commit("setIsSpeq", false);
                localStorage.removeItem("isSpeq");
            }
        } else {
            // if (!this.isSpeq) {
            if (isSpeq != 'true') {
                // this.switchToDealerPortal()
                this.$store.commit("setIsSpeq", false);
                localStorage.removeItem("isSpeq");
            }
        }

        // if (this.user.role.name != "super_admin") {
        if (this.user.role.id == 2 || this.user.role.id == 3) {
            if (this.currentLocation.id) {
                // do nothing
            } else {
                //
                if (this.user.locations.length > 1) {
                    let __is_speq = 0;
                    let __speq_invite_status = 0;

                    // this.user.locations_arr?.forEach((data) => {
                    //     if (data.is_speq)  __is_speq = 1;
                    //     if (data.speq_invite_status)  __speq_invite_status = 1;
                    // })
                    let selectedLocation = {
                        id: 0,
                        pricelist_id: 0,
                        name: "ALL LOCATIONS",
                        sales_rep: this.user.first_location.location.sales_rep,
                        is_speq: __is_speq,
                        speq_invite_status: __speq_invite_status
                    };
                    this.setCurrentLocation(selectedLocation);
                } else {
                    this.setCurrentLocation(this.user.first_location.location);
                }
            }

            if (!localStorage.hasOwnProperty("orders")) {
                localStorage.setItem("orders", JSON.stringify([]));
            }
            if (!localStorage.hasOwnProperty("po_number")) {
                localStorage.setItem("po_number", "");
            }
        } else {
            if (!localStorage.hasOwnProperty("products")) {
                localStorage.setItem("products", JSON.stringify([]));
            }
        }
        this.checkD2D();
    },
    methods: {
        closeModalStore() {
            this.modalShowStore = !this.modalShowStore;
            this.checkD2D();
        },

        checkD2D() {
            if (this.user.role.id != 1) {
                axios.get("/api/check-d2d-eligible").then((res) => {
                    this.showD2Dbtn = true;
                });
            }
        },
        switchToDealerPortal() {
            this.$store.commit("setIsSpeq", false);
            localStorage.removeItem("isSpeq");
            this.$router.push({ name: "dashboard" });
        },
    },
};
</script>
